import { createFileRoute } from '@tanstack/react-router';

import { TeamHomeRedirect } from '../app/team-home-redirect.js';

export const Route = createFileRoute('/_authed/')({
  component: TeamHomeRedirect,
});
